export default "__VITE_ASSET__BLNcK0Np__"